<template>
  <TaskDetails />
</template>

<script>
import TaskDetails from '@/components/TaskPage/TaskDetails'

export default {
  computed: {
  },
  methods: {
  },
  components: {
    TaskDetails
  }
};
</script>

<style>
</style>
